import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';


const StyledCard = styled((props) => (
  <Card {...props} />
))(({ theme }) => ({
  backgroundColor: 'transparent',
  border: 'none',
  boxShadow: 'none',
  borderRadius: "12px",
  paddingTop: '1.3rem',
  paddingBottom: '1.3rem',
  paddingLeft: '2rem',
  paddingRight: '2rem',
  margin: '1rem auto',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    width: 360,
  },
  [theme.breakpoints.up('md')]: {
    width: 480,
  },

}));


const EmailConfCard = ({ topic, content}) => {

    return (

      <StyledCard elevation={0}>
        <CardContent sx={{display: 'grid', placeItems: 'center', }}>

              <Typography variant="h2" align="center" color='common.black'> {topic}  </Typography>
        
                    {content}
        
        </CardContent> 
      </StyledCard>
    );
  };
  
  export default EmailConfCard;